// 宮崎県ローカルテレビクイズ100問
export const quizData = [
  // 第1章: 放送局の基本編 (問1-20)
  {
    id: 1,
    category: "放送局の基本",
    question: "宮崎県で最初の民間放送局として、1954年にラジオ放送を開始した放送局はどこでしょう？",
    options: [
      "テレビ宮崎 (UMK)",
      "宮崎放送 (MRT)",
      "NHK宮崎放送局",
      "エフエム宮崎 (JOY FM)"
    ],
    correctAnswer: 1,
    explanation: "宮崎放送(MRT)は、1954年7月1日に「ラジオ宮崎(RMK)」としてラジオ本放送を開始しました。宮崎県で最初の民間放送局です。"
  },
  {
    id: 2,
    category: "放送局の基本",
    question: "テレビ宮崎 (UMK) の本社があるのは宮崎市内のどこでしょう？",
    options: [
      "橘通西",
      "祇園",
      "江平西",
      "霧島"
    ],
    correctAnswer: 1,
    explanation: "テレビ宮崎(UMK)の本社は宮崎市祇園にあります。"
  },
  {
    id: 3,
    category: "放送局の基本",
    question: "NHK宮崎放送局の総合テレビのリモコンキーID（チャンネル番号）は何番でしょう？",
    options: [
      "1",
      "3",
      "6",
      "10"
    ],
    correctAnswer: 0,
    explanation: "NHK総合テレビのリモコンキーIDは全国共通で1番です。"
  },
  {
    id: 4,
    category: "放送局の基本",
    question: "宮崎放送 (MRT) の現在の本社は宮崎市のどこにあるでしょう？",
    options: [
      "祇園2丁目",
      "江平西2丁目",
      "橘通西4丁目",
      "橘通東4丁目"
    ],
    correctAnswer: 2,
    explanation: "宮崎放送(MRT)の本社は宮崎市橘通西4丁目の「MRTセンター」にあります。1984年に現在地に移転しました。"
  },
  {
    id: 5,
    category: "放送局の基本",
    question: "全国でも非常に珍しい、フジテレビ系列 (FNN)、日本テレビ系列 (NNN)、テレビ朝日系列 (ANN) の3つのニュースネットワークに加盟している放送局はどこでしょう？",
    options: [
      "宮崎放送 (MRT)",
      "NHK宮崎放送局",
      "テレビ宮崎 (UMK)",
      "鹿児島読売テレビ (KYT)"
    ],
    correctAnswer: 2,
    explanation: "テレビ宮崎(UMK)は、FNN・NNN・ANNの3系列クロスネットという全国でも極めて珍しい形態の放送局です。これは宮崎県独自のテレビ文化を育んできました。"
  },
  {
    id: 6,
    category: "放送局の基本",
    question: "NHK宮崎放送局の本社に最も近いJRの駅はどこでしょう？",
    options: [
      "宮崎駅",
      "南宮崎駅",
      "宮崎神宮駅",
      "蓮ケ池駅"
    ],
    correctAnswer: 2,
    explanation: "NHK宮崎放送局は宮崎市江平西にあり、最寄り駅は宮崎神宮駅です。"
  },
  {
    id: 7,
    category: "放送局の基本",
    question: "宮崎放送 (MRT) の略称「MRT」が意味するものは次のうちどれでしょう？",
    options: [
      "Miyazaki Regional Television",
      "Miyazaki Radio & Television",
      "Miyazaki Royal Television",
      "Miyazaki Rainbow Television"
    ],
    correctAnswer: 1,
    explanation: "MRTは「Miyazaki Radio & Television」の略称です。ラジオとテレビの両方を運営していることを示しています。"
  },
  {
    id: 8,
    category: "放送局の基本",
    question: "テレビ宮崎 (UMK) のコールサイン（識別信号）は何でしょう？",
    options: [
      "JOMG-DTV",
      "JONF-DTV",
      "JODI-DTV",
      "JOMC-DTV"
    ],
    correctAnswer: 2,
    explanation: "テレビ宮崎(UMK)のコールサインはJODI-DTVです。"
  },
  {
    id: 9,
    category: "放送局の基本",
    question: "宮崎放送 (MRT) の関連会社で、広告代理業務を主に行っている会社は何でしょう？",
    options: [
      "株式会社デンサン",
      "株式会社エムアールティ・ミック",
      "株式会社MRTアド",
      "株式会社トレードメディアジャパン"
    ],
    correctAnswer: 2,
    explanation: "株式会社MRTアドは、MRTの関連会社で広告代理業務を主に行っています。2008年7月14日に設立されました。"
  },
  {
    id: 10,
    category: "放送局の基本",
    question: "テレビ宮崎 (UMK) が海外友好局として提携している韓国の放送局はどこでしょう？",
    options: [
      "ソウル放送 (SBS)",
      "韓国放送公社 (KBS)",
      "文化放送 (MBC)",
      "大田放送 (TJB)"
    ],
    correctAnswer: 3,
    explanation: "テレビ宮崎(UMK)は韓国の大田放送(TJB)と海外友好局として提携しています。"
  },
  {
    id: 11,
    category: "放送局の基本",
    question: "NHK宮崎放送局の教育テレビ（Eテレ）のリモコンキーID（チャンネル番号）は何番でしょう？",
    options: [
      "1",
      "2",
      "7",
      "8"
    ],
    correctAnswer: 1,
    explanation: "NHK教育テレビ(Eテレ)のリモコンキーIDは全国共通で2番です。"
  },
  {
    id: 12,
    category: "放送局の基本",
    question: "宮崎放送 (MRT) のテレビネットワーク系列は次のうちどれでしょう？",
    options: [
      "日本テレビ系列 (NNS)",
      "テレビ朝日系列 (ANN)",
      "TBS系列 (JNN)",
      "フジテレビ系列 (FNS)"
    ],
    correctAnswer: 2,
    explanation: "宮崎放送(MRT)はTBS系列(JNN)に属しています。"
  },
  {
    id: 13,
    category: "放送局の基本",
    question: "テレビ宮崎 (UMK) の関連会社ではないものは次のうちどれでしょう？",
    options: [
      "株式会社UMKエージェンシー",
      "テレビ宮崎商事株式会社",
      "宮崎電子機器株式会社",
      "株式会社MRTアド"
    ],
    correctAnswer: 3,
    explanation: "株式会社MRTアドは宮崎放送(MRT)の関連会社です。"
  },
  {
    id: 14,
    category: "放送局の基本",
    question: "NHK宮崎放送局の所在地は宮崎市のどこでしょう？",
    options: [
      "宮崎市祇園",
      "宮崎市橘通西",
      "宮崎市江平西",
      "宮崎市下北方町"
    ],
    correctAnswer: 3,
    explanation: "NHK宮崎放送局は宮崎市下北方町にあります。1986年に現在地に移転しました。"
  },
  {
    id: 15,
    category: "放送局の基本",
    question: "宮崎放送 (MRT) の関連会社で、複合商業施設「MRT micc」の管理運営を行っている会社は何でしょう？",
    options: [
      "株式会社MRTアド",
      "株式会社デンサン",
      "株式会社エムアールティ・ミック",
      "エストレジャー有限会社"
    ],
    correctAnswer: 2,
    explanation: "株式会社エムアールティ・ミックが「MRT micc」の管理運営を行っています。"
  },
  {
    id: 16,
    category: "放送局の基本",
    question: "テレビ宮崎 (UMK) の資本金はいくらでしょう？",
    options: [
      "1億円",
      "1億6,200万円",
      "3億3,000万円",
      "5億円"
    ],
    correctAnswer: 2,
    explanation: "テレビ宮崎(UMK)の資本金は3億3,000万円です。"
  },
  {
    id: 17,
    category: "放送局の基本",
    question: "宮崎放送 (MRT) の2026年秋頃に移転が予定されている新社屋は、宮崎市のどこに建設中でしょう？",
    options: [
      "錦町",
      "祇園",
      "江平西",
      "橘通東"
    ],
    correctAnswer: 0,
    explanation: "宮崎放送(MRT)は2026年秋頃に宮崎市錦町に新社屋を移転する予定です。"
  },
  {
    id: 18,
    category: "放送局の基本",
    question: "テレビ宮崎 (UMK) が「健康経営優良法人」の認定を初めて取得したのは西暦何年からでしょう？",
    options: [
      "2015年",
      "2018年",
      "2020年",
      "2022年"
    ],
    correctAnswer: 2,
    explanation: "テレビ宮崎(UMK)は2020年に「健康経営優良法人」の認定を初めて取得しました。"
  },
  {
    id: 19,
    category: "放送局の基本",
    question: "NHK宮崎放送局のラジオ第1放送のコールサインは何でしょう？",
    options: [
      "JOMC",
      "JONF",
      "JODI",
      "JOMG"
    ],
    correctAnswer: 3,
    explanation: "NHK宮崎放送局のラジオ第1放送のコールサインはJOMGです。"
  },
  {
    id: 20,
    category: "放送局の基本",
    question: "宮崎放送 (MRT) の資本金はいくらでしょう？",
    options: [
      "1億円",
      "3億3,000万円",
      "5,000万円",
      "1,000万円"
    ],
    correctAnswer: 0,
    explanation: "宮崎放送(MRT)の資本金は1億円です。"
  },

  // 第2章: 歴史と歩み編 (問21-40)
  {
    id: 21,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) が「ラジオ宮崎 (RMK)」としてラジオ本放送を開始したのはいつでしょう？",
    options: [
      "1953年7月1日",
      "1954年7月1日",
      "1954年10月1日",
      "1960年10月1日"
    ],
    correctAnswer: 1,
    explanation: "宮崎放送(MRT)は1954年7月1日に「ラジオ宮崎(RMK)」としてラジオ本放送を開始しました。"
  },
  {
    id: 22,
    category: "歴史と歩み",
    question: "テレビ宮崎 (UMK) が開局したのはいつでしょう？",
    options: [
      "1960年4月1日",
      "1965年4月1日",
      "1970年4月1日",
      "1975年4月1日"
    ],
    correctAnswer: 2,
    explanation: "テレビ宮崎(UMK)は1970年4月1日に開局しました。"
  },
  {
    id: 23,
    category: "歴史と歩み",
    question: "NHK宮崎放送局が総合テレビの放送を開始したのはいつでしょう？",
    options: [
      "1954年7月1日",
      "1960年7月1日",
      "1963年12月1日",
      "1966年3月22日"
    ],
    correctAnswer: 1,
    explanation: "NHK宮崎放送局は1960年7月1日に総合テレビの放送を開始しました。"
  },
  {
    id: 24,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) がアナログテレビ放送を開始したのはいつでしょう？",
    options: [
      "1954年10月1日",
      "1960年10月1日",
      "1961年7月1日",
      "1966年12月10日"
    ],
    correctAnswer: 1,
    explanation: "宮崎放送(MRT)は1960年10月1日にアナログテレビ放送を開始しました。"
  },
  {
    id: 25,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) が、開局25周年を記念して1979年に宮崎市民会館から全国へ生放送したTBSテレビの伝説的な番組は何でしょう？",
    options: [
      "ザ・ベストテン",
      "3年B組金八先生",
      "8時だョ!全員集合",
      "クイズダービー"
    ],
    correctAnswer: 2,
    explanation: "1979年、開局25周年を記念して「8時だョ!全員集合」が宮崎市民会館から全国へ生放送されました。"
  },
  {
    id: 26,
    category: "歴史と歩み",
    question: "テレビ宮崎 (UMK) が、全国に先駆けてENGシステムを導入し「ENG先進局」として知られるようになったのは何年でしょう？",
    options: [
      "1970年",
      "1976年",
      "1980年",
      "1985年"
    ],
    correctAnswer: 1,
    explanation: "テレビ宮崎(UMK)は1976年に全国に先駆けてENGシステム(電子ニュース取材システム)を導入し、「ENG先進局」として知られるようになりました。"
  },
  {
    id: 27,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) が、現在の「宮崎放送」という社名に変更したのはいつでしょう？",
    options: [
      "1954年7月1日",
      "1960年10月1日",
      "1961年7月1日",
      "1984年9月1日"
    ],
    correctAnswer: 2,
    explanation: "宮崎放送(MRT)は1961年7月1日に「ラジオ宮崎」から現在の「宮崎放送」に社名変更しました。"
  },
  {
    id: 28,
    category: "歴史と歩み",
    question: "NHK宮崎放送局がラジオ第1放送を開始したのは1937年ですが、その当時の放送局は宮崎市のどこにありましたか？",
    options: [
      "現在と同じ江平西",
      "橘通",
      "鶴島（旧：下水流町）",
      "霧島"
    ],
    correctAnswer: 2,
    explanation: "NHK宮崎放送局は1937年にラジオ第1放送を開始しました。当時は宮崎市鶴島(旧：下水流町)にありました。"
  },
  {
    id: 29,
    category: "歴史と歩み",
    question: "テレビ宮崎 (UMK) がNNN（日本ニュースネットワーク）のニュース協定に調印したのはいつでしょう？",
    options: [
      "1970年（開局時）",
      "1973年",
      "1976年",
      "1979年"
    ],
    correctAnswer: 3,
    explanation: "テレビ宮崎(UMK)は1979年にNNN（日本ニュースネットワーク）のニュース協定に調印しました。"
  },
  {
    id: 30,
    category: "歴史と歩み",
    question: "宮崎県で地上デジタル放送の本放送が開始されたのはいつでしょう？",
    options: [
      "2003年12月1日",
      "2005年12月1日",
      "2006年12月1日",
      "2011年7月24日"
    ],
    correctAnswer: 2,
    explanation: "宮崎県では2006年12月1日に地上デジタル放送の本放送が開始されました。"
  },
  {
    id: 31,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) の複合施設「MRTセンター」（社屋、MRT micc、MRTパーキング）がオープンし、本社が現在の橘通りに移転したのは何年でしょう？",
    options: [
      "1978年",
      "1984年",
      "1990年",
      "1995年"
    ],
    correctAnswer: 1,
    explanation: "宮崎放送(MRT)は1984年に「MRTセンター」がオープンし、本社が現在の橘通りに移転しました。"
  },
  {
    id: 32,
    category: "歴史と歩み",
    question: "テレビ宮崎 (UMK) が開局20周年を迎えた1990年に創設した、広告文化の質的向上を目的とした賞は何でしょう？",
    options: [
      "UMK CM大賞",
      "UMK広告賞",
      "宮崎CMグランプリ",
      "UMKデザインアワード"
    ],
    correctAnswer: 0,
    explanation: "テレビ宮崎(UMK)は開局20周年を迎えた1990年に「UMK CM大賞」を創設しました。"
  },
  {
    id: 33,
    category: "歴史と歩み",
    question: "NHK宮崎放送局が現在の宮崎市江平西に放送会館を移転したのは何年でしょう？",
    options: [
      "1960年",
      "1967年",
      "1971年",
      "1986年"
    ],
    correctAnswer: 3,
    explanation: "NHK宮崎放送局は1986年に現在の宮崎市江平西(下北方町)に放送会館を移転しました。"
  },
  {
    id: 34,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) がインターネットIPサイマルラジオ「radiko」に参加し、宮崎県内での配信を開始したのは何年でしょう？",
    options: [
      "2010年",
      "2012年",
      "2014年",
      "2016年"
    ],
    correctAnswer: 1,
    explanation: "宮崎放送(MRT)は2012年にインターネットIPサイマルラジオ「radiko」に参加し、宮崎県内での配信を開始しました。"
  },
  {
    id: 35,
    category: "歴史と歩み",
    question: "テレビ宮崎 (UMK) の夕方のニュース番組。1979年から放送された『UMKニュースレポート』の前身番組は何でしょう？",
    options: [
      "UMKローカルニュース",
      "UMKニュース6:45",
      "UMKニュースTODAY",
      "UMKイブニングニュース"
    ],
    correctAnswer: 1,
    explanation: "『UMKニュースレポート』の前身番組は『UMKニュース6:45』でした。"
  },
  {
    id: 36,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) のAMラジオ都城放送局が開局したのはいつでしょう？",
    options: [
      "1954年7月1日",
      "1956年11月1日",
      "1958年5月1日",
      "1962年3月1日"
    ],
    correctAnswer: 2,
    explanation: "宮崎放送(MRT)のAMラジオ都城放送局は1958年5月1日に開局しました。"
  },
  {
    id: 37,
    category: "歴史と歩み",
    question: "2003年6月、宮崎放送 (MRT) の関連施設で簡易式爆発物が爆発する事件が発生しました。その施設はどこでしょう？",
    options: [
      "MRT本社",
      "MRT micc",
      "MRTパーキング",
      "MRTラジオ送信所"
    ],
    correctAnswer: 1,
    explanation: "2003年6月、MRT miccで簡易式爆発物が爆発する事件が発生しました。"
  },
  {
    id: 38,
    category: "歴史と歩み",
    question: "テレビ宮崎 (UMK) が開局50周年を迎えたのはいつでしょう？",
    options: [
      "2010年4月1日",
      "2015年4月1日",
      "2020年4月1日",
      "2025年4月1日"
    ],
    correctAnswer: 2,
    explanation: "テレビ宮崎(UMK)は1970年4月1日に開局し、2020年4月1日に開局50周年を迎えました。"
  },
  {
    id: 39,
    category: "歴史と歩み",
    question: "宮崎放送 (MRT) が、AMラジオの難聴取対策としてFM補完中継局（ワイドFM）の本放送を宮崎局で開始したのはいつでしょう？",
    options: [
      "2014年4月1日",
      "2015年4月1日",
      "2016年4月1日",
      "2017年4月1日"
    ],
    correctAnswer: 2,
    explanation: "宮崎放送(MRT)は2016年4月1日にFM補完中継局(ワイドFM)の本放送を宮崎局で開始しました。"
  },
  {
    id: 40,
    category: "歴史と歩み",
    question: "日本のアナログテレビ放送が終了したのは2011年7月24日です。この日、宮崎のテレビ局もアナログ放送を終えました。さて、この出来事は何と呼ばれているでしょう？",
    options: [
      "地デジ化",
      "停波",
      "アナログ停波",
      "完全デジタル化"
    ],
    correctAnswer: 0,
    explanation: "2011年7月24日の出来事は一般的に「地デジ化」と呼ばれています。"
  },

  // 第3章: 看板番組編 (問41-65)
  {
    id: 41,
    category: "看板番組",
    question: "MRT宮崎放送で、毎週月曜日から金曜日の夕方に放送されている報道情報番組の名前は何でしょう？",
    options: [
      "MRTニュース Next",
      "Check!",
      "イブニング・プレス",
      "みやざきTODAY"
    ],
    correctAnswer: 1,
    explanation: "MRT宮崎放送の夕方の報道情報番組は『Check!』です。県民に親しまれている人気番組です。"
  },
  {
    id: 42,
    category: "看板番組",
    question: "UMKテレビ宮崎で、毎週火曜日のゴールデンタイムに放送されているローカルバラエティ番組は何でしょう？",
    options: [
      "UMKスーパーサタデー",
      "じゃがじゃがサタデー",
      "火曜ゴールデン よかばん!!",
      "HOTWAVE"
    ],
    correctAnswer: 2,
    explanation: "UMKテレビ宮崎の火曜ゴールデンタイムには『火曜ゴールデン よかばん!!』が放送されています。"
  },
  {
    id: 43,
    category: "看板番組",
    question: "1977年から1992年までUMKテレビ宮崎で放送され、その独特なゆるさとハプニングで全国的にも有名になった伝説の土曜お昼の番組は何でしょう？",
    options: [
      "スタジオ3時",
      "さんさんサタデー",
      "JAGAJAGA天国",
      "MIYAZAKI土曜メッセ"
    ],
    correctAnswer: 1,
    explanation: "『さんさんサタデー』は1977年から1992年まで放送された伝説の番組で、そのゆるさとハプニングで全国的にも有名になりました。"
  },
  {
    id: 44,
    category: "看板番組",
    question: "MRT宮崎放送で毎週水曜日の夜に放送されている情報バラエティ番組で、宮崎弁の「若者」を意味するタイトルが付けられているのは何でしょう？",
    options: [
      "どようだよ",
      "わけもん!!",
      "てげビビ!",
      "おしえて！みやざき"
    ],
    correctAnswer: 1,
    explanation: "『わけもん!!』は宮崎弁で「若者」を意味し、MRT宮崎放送で毎週水曜日の夜に放送されている情報バラエティ番組です。"
  },
  {
    id: 45,
    category: "看板番組",
    question: "NHK宮崎放送局で、2022年4月から放送されている夕方のローカルニュース番組。宮崎弁の「とても」を意味する言葉がタイトルに入っている番組名は何でしょう？",
    options: [
      "いっちゃがラジオ",
      "みやざきスペシャル",
      "てげビビ!",
      "ニュースWAVE宮崎"
    ],
    correctAnswer: 2,
    explanation: "NHK宮崎放送局の夕方のローカルニュース番組は『てげビビ!』です。「てげ」は宮崎弁で「とても」を意味します。"
  },
  {
    id: 46,
    category: "看板番組",
    question: "MRT宮崎放送の土曜お昼の生放送番組『つづくさんのどようだよ(^^)』。番組開始当初の放送時間帯はいつだったでしょう？",
    options: [
      "土曜 12:10 - 13:30",
      "土曜 9:25 - 11:00",
      "土曜 9:45 - 10:30",
      "土曜 16:00 - 16:54"
    ],
    correctAnswer: 2,
    explanation: "『つづくさんのどようだよ(^^)』は番組開始当初、土曜9:45～10:30に放送されていました。"
  },
  {
    id: 47,
    category: "看板番組",
    question: "UMKテレビ宮崎の『火曜ゴールデン よかばん!!』の番組名の「よかばん」が意味する宮崎弁は「良い夜」ですが、もう一つ考えられる意味は何でしょう？",
    options: [
      "夜の看板",
      "夜の鞄",
      "よくばり",
      "良かったね"
    ],
    correctAnswer: 1,
    explanation: "「よかばん」は「良い夜」という意味と、「夜の鞄」という二つの意味がかけられています。"
  },
  {
    id: 48,
    category: "看板番組",
    question: "MRT宮崎放送の『わけもん!!』に、2023年3月まで12年間にわたって出演し、「宮崎ぶらり旅」などの人気コーナーを担当した俳優は誰でしょう？",
    options: [
      "温水洋一",
      "永瀬正敏",
      "堺雅人",
      "藤岡弘、"
    ],
    correctAnswer: 3,
    explanation: "俳優の藤岡弘、さんが『わけもん!!』に2023年3月まで12年間出演し、「宮崎ぶらり旅」などの人気コーナーを担当しました。"
  },
  {
    id: 49,
    category: "看板番組",
    question: "1995年から2012年までUMKテレビ宮崎で放送された『JAGAJAGA天国』。えびの市の伝統行事「もっかんじん」のリポートで、お酒を飲みすぎて病院に運ばれたエピソードで有名になった元UMKアナウンサーは誰でしょう？",
    options: [
      "鶴衛真理",
      "枦山珠代",
      "佐々木裕子",
      "赤間瞳"
    ],
    correctAnswer: 1,
    explanation: "元UMKアナウンサーの枦山珠代さんが『JAGAJAGA天国』の「もっかんじん」リポートでお酒を飲みすぎて病院に運ばれたエピソードで有名になりました。"
  },
  {
    id: 50,
    category: "看板番組",
    question: "MRT宮崎放送の『Check!』のメインキャスターの一人で、長年MRTの「夕方の顔」として知られているアナウンサーは誰でしょう？",
    options: [
      "粉川真一",
      "川野武文",
      "中野義大",
      "澁谷祐太朗"
    ],
    correctAnswer: 1,
    explanation: "川野武文アナウンサーはMRT宮崎放送の『Check!』のメインキャスターの一人で、長年「夕方の顔」として親しまれています。"
  },
  {
    id: 51,
    category: "看板番組",
    question: "NHK宮崎放送局の『てげビビ!』で、宮崎局に保管されている過去の映像から当時の出来事を振り返るコーナー名は何でしょう？",
    options: [
      "プレイバック宮崎",
      "あの日の宮崎",
      "映像みやざきアーカイブス",
      "蔵出し！みやざき"
    ],
    correctAnswer: 3,
    explanation: "NHK宮崎放送局の『てげビビ!』には、過去の映像を振り返るコーナー『蔵出し！みやざき』があります。"
  },
  {
    id: 52,
    category: "看板番組",
    question: "UMKテレビ宮崎の『火曜ゴールデン よかばん!!』で、宮崎県内の市町村で一番標高の高い場所にある家を探すという企画のコーナー名は何でしょう？",
    options: [
      "てっぺんハウス",
      "ちょっぺんハウス",
      "やまびこハウス",
      "そらとぶハウス"
    ],
    correctAnswer: 1,
    explanation: "『火曜ゴールデン よかばん!!』の人気コーナー『ちょっぺんハウス』は、県内で一番標高の高い場所にある家を探す企画です。"
  },
  {
    id: 53,
    category: "看板番組",
    question: "MRT宮崎放送の『つづくさんのどようだよ(^^)』の人気コーナーで、かわいい園児たちがクイズに挑戦するコーナー名は何でしょう？",
    options: [
      "ちびっこクイズ",
      "わんぱくクイズ",
      "天才ちびっこクイズ",
      "なぞQキッズ"
    ],
    correctAnswer: 3,
    explanation: "『つづくさんのどようだよ(^^)』の人気コーナー『なぞQキッズ』では、かわいい園児たちがクイズに挑戦します。"
  },
  {
    id: 54,
    category: "看板番組",
    question: "UMKテレビ宮崎の伝説の番組『さんさんサタデー』の放送回数は、1992年に終了するまで全何回だったでしょう？",
    options: [
      "555回",
      "678回",
      "788回",
      "1000回"
    ],
    correctAnswer: 2,
    explanation: "『さんさんサタデー』は1977年から1992年まで全788回放送されました。"
  },
  {
    id: 55,
    category: "看板番組",
    question: "MRT宮崎放送の『わけもん!!』の前身番組で、2009年から2011年まで土曜日に放送されていた番組名は何でしょう？",
    options: [
      "わけもん!",
      "わけもん! GT",
      "わけもん! Z",
      "わけもん! NEO"
    ],
    correctAnswer: 0,
    explanation: "『わけもん!!』の前身番組は『わけもん!』で、2009年から2011年まで土曜日に放送されていました。"
  },
  {
    id: 56,
    category: "看板番組",
    question: "NHK宮崎放送局の『てげビビ!』で、気象情報を担当している気象予報士は誰でしょう？ (2024年時点)",
    options: [
      "福田裕大",
      "岡野暁",
      "堀井優太",
      "大平真理子"
    ],
    correctAnswer: 3,
    explanation: "NHK宮崎放送局の『てげビビ!』で気象情報を担当しているのは気象予報士の大平真理子さんです。"
  },
  {
    id: 57,
    category: "看板番組",
    question: "UMKテレビ宮崎で放送されていた『JAGAJAGA天国』の初代男性司会を務めた元UMKアナウンサーは誰でしょう？",
    options: [
      "佐々木六華",
      "南出雅之",
      "高橋巨典",
      "相田久雄"
    ],
    correctAnswer: 2,
    explanation: "『JAGAJAGA天国』の初代男性司会を務めたのは元UMKアナウンサーの高橋巨典さんです。"
  },
  {
    id: 58,
    category: "看板番組",
    question: "MRT宮崎放送の『つづくさんのどようだよ(^^)』で、赤ちゃんのハイハイレースを実況する名物コーナー名は何でしょう？",
    options: [
      "GO! GO! BABY",
      "はいはいグランプリ",
      "丸商建設 赤ちゃんだっしゅ♪",
      "ベビーレースGO!"
    ],
    correctAnswer: 2,
    explanation: "『つづくさんのどようだよ(^^)』の名物コーナー『丸商建設 赤ちゃんだっしゅ♪』では、赤ちゃんのハイハイレースが実況されます。"
  },
  {
    id: 59,
    category: "看板番組",
    question: "UMKテレビ宮崎の『火曜ゴールデン よかばん!!』で、佐々木六華アナウンサーが県内市町村を舞台にガチャガチャから出る難題に挑むコーナー名は何でしょう？",
    options: [
      "ガチャぶら！",
      "ガチャロッカ!!",
      "ろっかの挑戦",
      "ガチャっと宮崎"
    ],
    correctAnswer: 1,
    explanation: "『火曜ゴールデン よかばん!!』の人気コーナー『ガチャロッカ!!』では、佐々木六華アナウンサーがガチャガチャから出る難題に挑みます。"
  },
  {
    id: 60,
    category: "看板番組",
    question: "MRT宮崎放送の『わけもん!!』で、2024年に宮崎市で開催された「ひなたフェス」に合わせて、毎週放送されたコーナー名は何でしょう？",
    options: [
      "日向坂46宮崎応援団",
      "週刊ひなたフェス",
      "週刊日向坂ニュース",
      "GO! GO! HINATAZAKA"
    ],
    correctAnswer: 2,
    explanation: "『わけもん!!』では、2024年の「ひなたフェス」に合わせて『週刊日向坂ニュース』が毎週放送されました。"
  },
  {
    id: 61,
    category: "看板番組",
    question: "NHK宮崎放送局で、2018年春の改編から一時期、土日祝日のローカルニュースが原則として集約されたのは、どこの放送局から発信されるブロックニュースだったでしょう？",
    options: [
      "熊本放送局",
      "鹿児島放送局",
      "福岡放送局",
      "東京アナウンス室"
    ],
    correctAnswer: 2,
    explanation: "NHK宮崎放送局では、2018年春の改編から一時期、土日祝日のローカルニュースが福岡放送局から発信されるブロックニュースに集約されました。"
  },
  {
    id: 62,
    category: "看板番組",
    question: "UMKテレビ宮崎の『さんさんサタデー』で、「元祖ごはんマン」として活躍した元UMKアナウンサーは誰でしょう？",
    options: [
      "高橋巨典",
      "塚田誉",
      "相田久雄",
      "南出雅之"
    ],
    correctAnswer: 2,
    explanation: "元UMKアナウンサーの相田久雄さんが『さんさんサタデー』で「元祖ごはんマン」として活躍しました。"
  },
  {
    id: 63,
    category: "看板番組",
    question: "MRT宮崎放送の平日朝のローカルワイド番組として、1984年に放送を開始し、その後番組名を変えながら2021年まで続いた長寿番組枠の最初の番組名は何でしょう？",
    options: [
      "おはよう奥さん",
      "あさトク!",
      "おくさま9:30",
      "モーニングてらす"
    ],
    correctAnswer: 2,
    explanation: "MRT宮崎放送の平日朝のローカルワイド番組は、1984年に『おくさま9:30』として放送を開始しました。"
  },
  {
    id: 64,
    category: "看板番組",
    question: "UMKテレビ宮崎で、土曜夕方に放送されている情報番組『U-doki』が放送開始したのは何年でしょう？",
    options: [
      "2005年",
      "2008年",
      "2012年",
      "2014年"
    ],
    correctAnswer: 2,
    explanation: "UMKテレビ宮崎の情報番組『U-doki』は2012年に放送開始しました。"
  },
  {
    id: 65,
    category: "看板番組",
    question: "『わけもん!!』がゴールデンタイムに進出した際の番組名は『わけもん! GT』でしたが、この「GT」は何の略だったでしょう？",
    options: [
      "Great Time",
      "Golden Time",
      "Grand Touring",
      "Go To"
    ],
    correctAnswer: 1,
    explanation: "『わけもん! GT』の「GT」は「Golden Time(ゴールデンタイム)」の略です。"
  },

  // 第4章: 宮崎の顔！人気パーソナリティ編 (問66-80)
  {
    id: 66,
    category: "人気パーソナリティ",
    question: "UMKテレビ宮崎の『さんさんサタデー』などで活躍したMr.バニー。彼の本名は何でしょう？",
    options: [
      "成井一充",
      "田口泰久",
      "重信優",
      "南出雅之"
    ],
    correctAnswer: 0,
    explanation: "Mr.バニーの本名は成井一充(なるい かずみつ)さんです。"
  },
  {
    id: 67,
    category: "人気パーソナリティ",
    question: "MRT宮崎放送の『つづくさんのどようだよ(^^)』のMCを務める木村つづく。彼の出身地は宮崎県内のどこでしょう？",
    options: [
      "宮崎市",
      "都城市",
      "延岡市",
      "日南市"
    ],
    correctAnswer: 2,
    explanation: "木村つづくさんの出身地は宮崎県延岡市です。"
  },
  {
    id: 68,
    category: "人気パーソナリティ",
    question: "FM宮崎の『Radio Paradise 耳が恋した！』のパーソナリティで、UMKテレビ宮崎の『火曜ゴールデン よかばん!!』にも出演しているミュージシャンは誰でしょう？",
    options: [
      "Mr.バニー",
      "木村つづく",
      "濱田詩朗",
      "ジェイミー・ハバード"
    ],
    correctAnswer: 2,
    explanation: "濱田詩朗さんはFM宮崎のパーソナリティであり、UMKテレビ宮崎の『火曜ゴールデン よかばん!!』にも出演しているミュージシャンです。"
  },
  {
    id: 69,
    category: "人気パーソナリティ",
    question: "Mr.バニーの奥様は元テレビ宮崎のアナウンサーです。その奥様の旧姓（結婚前の姓）は何でしょう？",
    options: [
      "戸澤",
      "貴島",
      "島崎",
      "飛松"
    ],
    correctAnswer: 2,
    explanation: "Mr.バニーの奥様の旧姓は島崎です。元テレビ宮崎のアナウンサーでした。"
  },
  {
    id: 70,
    category: "人気パーソナリティ",
    question: "木村つづくはラジオパーソナリティになる前、ある職業に就いていました。それは何でしょう？",
    options: [
      "銀行員",
      "教師",
      "広告代理店勤務",
      "公務員"
    ],
    correctAnswer: 2,
    explanation: "木村つづくさんはラジオパーソナリティになる前、広告代理店に勤務していました。"
  },
  {
    id: 71,
    category: "人気パーソナリティ",
    question: "濱田詩朗の家族には音楽や演芸に関わる人物がいます。彼の祖父の職業は何だったでしょう？",
    options: [
      "トランペッター",
      "演歌歌手",
      "落語家",
      "浪曲師"
    ],
    correctAnswer: 2,
    explanation: "濱田詩朗さんの祖父は落語家でした。"
  },
  {
    id: 72,
    category: "人気パーソナリティ",
    question: "Mr.バニーは大学在学中からテレビ宮崎でアルバイトをしていましたが、卒業後、最初に配属された部署はどこだったでしょう？",
    options: [
      "報道部",
      "営業部",
      "アナウンス部",
      "制作部"
    ],
    correctAnswer: 3,
    explanation: "Mr.バニーは大学卒業後、最初に制作部に配属されました。"
  },
  {
    id: 73,
    category: "人気パーソナリティ",
    question: "木村つづくは、2023年に開催されたG7宮崎農業大臣会合で、ある重要な役割を担いました。それは何でしょう？",
    options: [
      "実行委員長",
      "広報PR大使",
      "公式通訳",
      "総合プロデューサー"
    ],
    correctAnswer: 1,
    explanation: "木村つづくさんは、2023年のG7宮崎農業大臣会合で広報PR大使を務めました。"
  },
  {
    id: 74,
    category: "人気パーソナリティ",
    question: "濱田詩朗の弟・明良と兄弟でパーソナリティを務めているラジオ番組が放送されている放送局はどこでしょう？",
    options: [
      "MRTラジオ",
      "FM宮崎 (JOY FM)",
      "宮崎サンシャインエフエム",
      "FMひゅうが"
    ],
    correctAnswer: 2,
    explanation: "濱田詩朗さんと弟の明良さんは、宮崎サンシャインエフエムで兄弟でパーソナリティを務めています。"
  },
  {
    id: 75,
    category: "人気パーソナリティ",
    question: "Mr.バニーに影響を受け、彼を憧れの人だと公言している宮崎市出身のお笑い芸人は誰でしょう？",
    options: [
      "蛙亭・イワクラ",
      "やす",
      "永野",
      "とろサーモン・久保田"
    ],
    correctAnswer: 2,
    explanation: "お笑い芸人の永野さんは宮崎市出身で、Mr.バニーを憧れの人だと公言しています。"
  },
  {
    id: 76,
    category: "人気パーソナリティ",
    question: "木村つづくが代表取締役を務める企画会社の名前は何でしょう？",
    options: [
      "株式会社つづくプランニング",
      "あそびば株式会社",
      "株式会社キムラクリエイト",
      "宮崎エンタープライズ株式会社"
    ],
    correctAnswer: 1,
    explanation: "木村つづくさんが代表取締役を務める企画会社は「あそびば株式会社」です。"
  },
  {
    id: 77,
    category: "人気パーソナリティ",
    question: "濱田詩朗がMCを務める宮崎ケーブルテレビの番組『こちら祇園二丁目濱田製作所』。この「祇園二丁目」とは、どのテレビ局の所在地を指しているでしょう？",
    options: [
      "MRT宮崎放送",
      "UMKテレビ宮崎",
      "NHK宮崎放送局",
      "宮崎ケーブルテレビ"
    ],
    correctAnswer: 1,
    explanation: "「祇園二丁目」はUMKテレビ宮崎の所在地です。番組名はそこから由来しています。"
  },
  {
    id: 78,
    category: "人気パーソナリティ",
    question: "Mr.バニーは、2024年に公開された映画『ベイビーわるきゅーれ ナイスデイズ』に出演しました。彼が演じた役柄は何でしょう？",
    options: [
      "主人公の父親役",
      "刑事役",
      "宮崎土着の殺し屋集団のボス役",
      "学校の先生役"
    ],
    correctAnswer: 2,
    explanation: "Mr.バニーは映画『ベイビーわるきゅーれ ナイスデイズ』で宮崎土着の殺し屋集団のボス役を演じました。"
  },
  {
    id: 79,
    category: "人気パーソナリティ",
    question: "木村つづくが「みやこんじょ大使」を委嘱されたのは、宮崎県内のどの市からでしょう？",
    options: [
      "宮崎市",
      "延岡市",
      "日南市",
      "都城市"
    ],
    correctAnswer: 3,
    explanation: "木村つづくさんは都城市から「みやこんじょ大使」を委嘱されました。"
  },
  {
    id: 80,
    category: "人気パーソナリティ",
    question: "『さんさんサタデー』で活躍した「マー坊」こと重信優。番組を降板した理由として、彼自身が後に語ったのは何だったでしょう？",
    options: [
      "病気療養のため",
      "家業を継ぐため",
      "津軽三味線の修行と、海外公演のギャラが高かったため",
      "他局からの引き抜きがあったため"
    ],
    correctAnswer: 2,
    explanation: "重信優さん(マー坊)は、津軽三味線の修行と海外公演のギャラが高かったため、『さんさんサタデー』を降板したと語っています。"
  },

  // 第5章: 超マニアック！「てげ」ムズい編 (問81-100)
  {
    id: 81,
    category: "超マニアック",
    question: "MRT宮崎放送が2006年に制定した、局のシンボルキャラクター3体の名前の組み合わせとして正しいものはどれでしょう？",
    options: [
      "ミーヤ、アルくん、ティーちゃん",
      "ミーモ、くーたん、ぴよ蔵",
      "みやざき犬（ひぃ、むぅ、かぁ）",
      "フェニくん、マンゴーちゃん、チキンくん"
    ],
    correctAnswer: 1,
    explanation: "MRT宮崎放送のシンボルキャラクターは「ミーモ」「くーたん」「ぴよ蔵」の3体です。"
  },
  {
    id: 82,
    category: "超マニアック",
    question: "宮崎県のシンボルキャラクター「みやざき犬」。その派遣依頼や管理業務を行っている「みやざきキャラわん隊」は、どのテレビ局の関連会社に所属しているでしょう？",
    options: [
      "MRT宮崎放送（エムアールティ・ミック）",
      "UMKテレビ宮崎（テレビ宮崎商事）",
      "NHK宮崎放送局（NHKサービスセンター）",
      "宮崎県庁直轄"
    ],
    correctAnswer: 1,
    explanation: "「みやざきキャラわん隊」はUMKテレビ宮崎の関連会社であるテレビ宮崎商事に所属しています。"
  },
  {
    id: 83,
    category: "超マニアック",
    question: "「♪あんたどこ行きなさっと？ わたしゃナガトモに行くとよ」というおばあちゃんのセリフが印象的なCMで知られる、宮崎の老舗企業は何を扱っている会社でしょう？",
    options: [
      "仏壇・仏具",
      "呉服",
      "家具",
      "菓子"
    ],
    correctAnswer: 0,
    explanation: "このCMは仏壇・仏具を扱う「ナガトモ」のCMです。宮崎県民なら誰もが知る印象的なCMソングです。"
  },
  {
    id: 84,
    category: "超マニアック",
    question: "UMKテレビ宮崎が主催する夏の大型音楽イベント「JamNight」。このイベントの前身となったジャズフェスティバルの名前は何でしょう？",
    options: [
      "UMKフェニックスジャズイン",
      "宮崎シーサイドジャズ",
      "橘ジャズフェスティバル",
      "UMKミュージックフェスタ"
    ],
    correctAnswer: 0,
    explanation: "「JamNight」の前身は「UMKフェニックスジャズイン」でした。"
  },
  {
    id: 85,
    category: "超マニアック",
    question: "MRT宮崎放送が運営する宮崎の地域情報ポータルサイトの名前は何でしょう？",
    options: [
      "miyazaki-life",
      "hinata-navi",
      "miten",
      "jimo-miya"
    ],
    correctAnswer: 2,
    explanation: "MRT宮崎放送が運営する宮崎の地域情報ポータルサイトは「miten(みてん)」です。"
  },
  {
    id: 86,
    category: "超マニアック",
    question: "宮崎県出身の女優・宮崎美子さんが、デビューのきっかけとなったのは何のCMだったでしょう？",
    options: [
      "ミノルタカメラ",
      "キリンビール",
      "資生堂",
      "トヨタ自動車"
    ],
    correctAnswer: 0,
    explanation: "宮崎美子さんは「ミノルタカメラ」のCMでデビューしました。"
  },
  {
    id: 87,
    category: "超マニアック",
    question: "UMKテレビ宮崎は多角的な事業展開を行っていますが、次のうちUMKのグループ会社が運営しているゴルフ場はどれでしょう？",
    options: [
      "宮崎カントリークラブ",
      "フェニックスカントリークラブ",
      "青島ゴルフ倶楽部",
      "UMKカントリークラブ（テレビ宮崎ゴルフ株式会社）"
    ],
    correctAnswer: 3,
    explanation: "UMKテレビ宮崎のグループ会社「テレビ宮崎ゴルフ株式会社」が「UMKカントリークラブ」を運営しています。"
  },
  {
    id: 88,
    category: "超マニアック",
    question: "「♪サンサンサンA オレンジジュース」というCMソングで知られる「サンA」ブランドを展開している、宮崎の企業名は何でしょう？",
    options: [
      "宮崎県農協果汁",
      "南日本酪農協同",
      "霧島酒造",
      "雲海酒造"
    ],
    correctAnswer: 0,
    explanation: "「サンA」ブランドを展開しているのは「宮崎県農協果汁」です。"
  },
  {
    id: 89,
    category: "超マニアック",
    question: "MRT宮崎放送の関連会社「MRTアド」の設立年月日はいつでしょう？",
    options: [
      "1984年9月",
      "1995年6月",
      "2006年2月",
      "2008年7月14日"
    ],
    correctAnswer: 3,
    explanation: "株式会社MRTアドは2008年7月14日に設立されました。"
  },
  {
    id: 90,
    category: "超マニアック",
    question: "UMKテレビ宮崎が主催する女子プロゴルフトーナメントの現在の大会名は何でしょう？",
    options: [
      "ダンロップフェニックストーナメント",
      "LPGAツアーチャンピオンシップリコーカップ",
      "アクサレディスゴルフトーナメント in MIYAZAKI",
      "伊藤園レディスゴルフトーナメント"
    ],
    correctAnswer: 2,
    explanation: "UMKテレビ宮崎が主催する女子プロゴルフトーナメントは「アクサレディスゴルフトーナメント in MIYAZAKI」です。"
  },
  {
    id: 91,
    category: "超マニアック",
    question: "宮崎のローカルCMで、「♪お仏壇は～ もりさきで～」というフレーズの後に子供の声で続くセリフは何だったでしょう？",
    options: [
      "「おじいちゃんが言ってたよ」",
      "「お母さん、したて言よるわ～」",
      "「とってもきれいだね！」",
      "「ご先祖様もにっこり」"
    ],
    correctAnswer: 1,
    explanation: "もりさきのCMでは、「♪お仏壇は～ もりさきで～」の後に子供の声で「お母さん、したて言よるわ～」と続きます。"
  },
  {
    id: 92,
    category: "超マニアック",
    question: "MRT宮崎放送が主催する恒例のリスナー参加ツアーで、長寿ラジオ番組の名前を冠したものは「何と行く」ツアーでしょう？",
    options: [
      "フレッシュAMもぎたてラジオ",
      "GO！ GO！ ワイド ゆうくん・淳子",
      "スイッチ♪音Time",
      "MRT歌謡曲 ナイタースペシャル"
    ],
    correctAnswer: 1,
    explanation: "MRT宮崎放送の長寿ラジオ番組「GO！GO！ワイド ゆうくん・淳子」の名前を冠したリスナー参加ツアーがあります。"
  },
  {
    id: 93,
    category: "超マニアック",
    question: "宮崎県の木「フェニックス」や特産品をモチーフにしたVTuber「日向海フェニカ」。彼女が自分を作った博士を探す手がかりとして、目を覚ました研究所に残されていたものは何だったでしょう？",
    options: [
      "博士の日記",
      "壊れたコンピュータ",
      "わずかな手がかり",
      "一枚の写真"
    ],
    correctAnswer: 2,
    explanation: "VTuber「日向海フェニカ」は、研究所に残されていた「わずかな手がかり」をもとに博士を探しています。"
  },
  {
    id: 94,
    category: "超マニアック",
    question: "UMKテレビ宮崎は、テレビ東京系列の一部の番組も放送しています。次のうち、過去にUMKで放送されていなかった番組はどれでしょう？",
    options: [
      "ポケットモンスター",
      "たけしのニッポンのミカタ!",
      "モヤモヤさまぁ～ず2",
      "ワールドビジネスサテライト"
    ],
    correctAnswer: 3,
    explanation: "「ワールドビジネスサテライト」はUMKで放送されていませんでした。"
  },
  {
    id: 95,
    category: "超マニアック",
    question: "MRT宮崎放送の関連会社「デンサン」の主な事業内容は何でしょう？",
    options: [
      "広告代理業",
      "不動産管理",
      "イベント企画",
      "情報処理サービス"
    ],
    correctAnswer: 3,
    explanation: "株式会社デンサンの主な事業内容は情報処理サービスです。"
  },
  {
    id: 96,
    category: "超マニアック",
    question: "1980年代後半、『さんさんサタデー』が全国的に知られるきっかけとなった、明石家さんま・片岡鶴太郎が司会を務めたフジテレビの特別番組シリーズ名は何でしょう？",
    options: [
      "FNS番組対抗NG名珍場面大賞",
      "さんま・一機のその地方でしか見られない面白そうな番組を全国のみんなで楽しく見ちゃおうとする番組",
      "タモリ・さんまの日本一面白いテレビ",
      "オールスター番組対抗ボウリング大会"
    ],
    correctAnswer: 1,
    explanation: "『さんさんサタデー』が全国的に知られるきっかけとなったのは「さんま・一機のその地方でしか見られない面白そうな番組を全国のみんなで楽しく見ちゃおうとする番組」です。"
  },
  {
    id: 97,
    category: "超マニアック",
    question: "宮崎の結婚式場「ガーデンテラス宮崎」や「フェニックス・シーガイア・リゾート」などを運営する、かつてMRT宮崎放送のCMを多く手掛けた企業グループは何でしょう？",
    options: [
      "イオン",
      "セブン&アイ・ホールディングス",
      "一蔵",
      "文化コーポレーション"
    ],
    correctAnswer: 3,
    explanation: "文化コーポレーションが宮崎の結婚式場やリゾート施設を運営し、MRT宮崎放送のCMを多く手掛けていました。"
  },
  {
    id: 98,
    category: "超マニアック",
    question: "MRT宮崎放送のAMラジオの基幹送信所（親局）は、宮崎市のどこにあるでしょう？",
    options: [
      "鰐塚山",
      "霧島",
      "一ツ葉",
      "青島"
    ],
    correctAnswer: 1,
    explanation: "MRT宮崎放送のAMラジオの基幹送信所(親局)は宮崎市霧島にあります。"
  },
  {
    id: 99,
    category: "超マニアック",
    question: "UMKテレビ宮崎の2024年3月期の売上高に最も近い金額はどれでしょう？",
    options: [
      "約55億円",
      "約69億円",
      "約82億円",
      "約100億円"
    ],
    correctAnswer: 1,
    explanation: "UMKテレビ宮崎の2024年3月期の売上高は約69億円です。"
  },
  {
    id: 100,
    category: "超マニアック",
    question: "MRT宮崎放送が2021年5月に加盟を表明した、国連が提唱する持続可能な開発目標 (SDGs) の達成に向けたメディアの行動指針は何でしょう？",
    options: [
      "SDGsメディア・イニシアチブ",
      "SDGsメディア・コンパクト",
      "メディア・フォー・SDGs",
      "グローバル・メディア・ゴールズ"
    ],
    correctAnswer: 1,
    explanation: "MRT宮崎放送は2021年5月に国連が提唱する「SDGsメディア・コンパクト」への加盟を表明しました。"
  }
];
